import CompanySearch from "@/app/core/layouts/main-components/input/CompanySearch";
import CheckMobile from "@/app/core/util/Screen";
import React, { useEffect, useState } from "react";

export default function MegaBanner({whats, whatsNumber}) {
  let screenWidth = CheckMobile();

  function onItemSelected(data) {
    window.location = `#/reclamar/?empresa=${data.id}&name=${data.name}`;
  }

  return (
    <div
      id="banner"
      className=""
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL + "/assets/media/banner.png"})`, marginTop: -70, height: 492, backgroundRepeat: "no-repeat", backgroundSize: "cover", zIndex: 99 }}
    >
      <div className="py-7">
        <div className={"text-center"}>
          <div className={"ml-2 mr-2 text-center"}>
            <h1 className="font-w700 text-white py-5">Prezado consumidor, <br />
              aqui você é ouvido e o seu problema resolvido!</h1>
              {screenWidth == false ?
            <div className="row mt-4">
              <div className="col-md-3"></div>
              <div className="col-md-6" style={{zIndex:10}}>
                {whats === true ? 
                <a className="btn btn-lg btn-success" href={`https://wa.me/${whatsNumber ?? "5521971160297"}?text=%2APrezado%20Consumidor%2C%20preencha%20os%20dados%20abaixo%20para%20Reclamar%2A%20%F0%9F%93%A2%20%0ASeu%20nome%3A%0ASua%20Cidade%3A%0AEmpresa%20Reclamada%3A%0ASua%20Reclama%C3%A7%C3%A3o%F0%9F%93%A3%3A`}><i className="fab fa-whatsapp"/> Reclame pelo WhatsApp</a>
                :
                <CompanySearch onFullSelection={id => onItemSelected(id)}/>
                }
              </div>
              <div className="col-md-3"></div>
            </div>
        :
              <div className="" style={{zIndex:10}}>
                {whats === true ? 
                <a className="btn btn-lg btn-success" href={`https://wa.me/${whatsNumber ?? "5521971160297"}?text=%2APrezado%20Consumidor%2C%20preencha%20os%20dados%20abaixo%20para%20Reclamar%2A%20%F0%9F%93%A2%20%0ASeu%20nome%3A%0ASua%20Cidade%3A%0AEmpresa%20Reclamada%3A%0ASua%20Reclama%C3%A7%C3%A3o%F0%9F%93%A3%3A`}><i className="fab fa-whatsapp"/> Reclame pelo WhatsApp</a>
                :
                <CompanySearch onFullSelection={id => onItemSelected(id)}/>
                }
              </div>
      }

          </div>
        </div>
      </div>
    </div>
  );
}
